import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TicketState } from './types';

import { TicketType } from 'v2/constants';
import { TicketModel } from 'v2/types/TicketModel';

const initialState: TicketState = {
  ticketsList: [],
  unassignedTicketsList: [],
  ticketsPage: 1,
  ticketsTotalCount: 0,
  refreshTicketsTable: false,
};

export const ticketSlice = createSlice({
  name: 'ticket',
  initialState,
  reducers: {
    setTickets: (state: TicketState, { payload }: PayloadAction<TicketModel[]>) => {
      state.ticketsList = payload;
    },
    setUnassignedTickets: (state: TicketState, { payload }: PayloadAction<TicketModel[]>) => {
      state.unassignedTicketsList = payload;
    },
    setTicket: (state: TicketState, { payload }: PayloadAction<TicketModel>) => {
      const copiedArray = [...state.ticketsList];

      copiedArray.push(payload);

      state.ticketsList = copiedArray;
    },
    updateTicket: (state: TicketState, { payload }: PayloadAction<TicketModel>) => {
      const mappedTicketsList = state.ticketsList.map((ticket) => {
        const { id: ticketId } = ticket;
        const { id: payloadId } = payload;

        if (ticketId === payloadId) {
          return payload;
        }

        return ticket;
      });

      state.ticketsList = mappedTicketsList;
    },
    deleteTicket: (state: TicketState, { payload: ticketIdId }: PayloadAction<string>) => {
      const filteredTicketsList = state.ticketsList.filter((ticket) => {
        const { id: currentTicketId } = ticket;

        return ticketIdId !== currentTicketId;
      });

      state.ticketsList = filteredTicketsList;
    },
    setTicketsPage: (state: TicketState, { payload }: PayloadAction<number>) => {
      state.ticketsPage = payload;
    },
    setTicketsTotalCount: (state: TicketState, { payload }: PayloadAction<number>) => {
      state.ticketsTotalCount = payload;
    },
    refreshTicketsTable: (state: TicketState, { payload }: PayloadAction<boolean>) => {
      state.refreshTicketsTable = payload;
    },
    setContestTicketDefault: (
      state: TicketState,
      { payload }: PayloadAction<{ ticketId: string; isDefault: boolean }>
    ) => {
      const { ticketId, isDefault } = payload;

      state.ticketsList = state.ticketsList.map((ticket) => {
        if (ticket.type !== TicketType.CONTEST) {
          return ticket;
        }

        if (isDefault) {
          if (ticket.id === ticketId) {
            return { ...ticket, isDefault: true };
          } else {
            return { ...ticket, isDefault: false };
          }
        } else {
          if (ticket.id === ticketId) {
            return { ...ticket, isDefault: false };
          }
        }

        return ticket;
      });
    },
  },
});

export const {
  setTicket,
  deleteTicket,
  setTickets,
  setUnassignedTickets,
  updateTicket,
  setTicketsPage,
  setTicketsTotalCount,
  refreshTicketsTable,
  setContestTicketDefault,
} = ticketSlice.actions;

export const ticketSliceReducer = ticketSlice.reducer;
